import { render, staticRenderFns } from "./EmailSignatureModal.vue?vue&type=template&id=05dd1420"
import script from "./EmailSignatureModal.vue?vue&type=script&lang=js"
export * from "./EmailSignatureModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports